const { FIELD_TYPES } = require('@wix/dbsm-common/src/collections/consts')
const convertValueToString = require('./convertValueToString')
const isNil_ = require('lodash/isNil')

module.exports = (initValue, { fieldType, shouldConvertToString }) => {
  let value

  if (!isNil_(initValue)) {
    switch (fieldType) {
      case FIELD_TYPES.ADDRESS:
        const { formatted } = initValue
        value = formatted
        break
      default:
        value = initValue
    }
  }

  return shouldConvertToString ? convertValueToString(value) : value
}
